import React from 'react';
import { Route } from 'react-router-dom';
import ScreenLayout from '../screen/ScreenLayout';
import { NavigationRoute } from '../../../api/Navigation';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import PortalContextProvider from '../../../portal/context/PortalContextProvider';

export type RouteWrapperProps = NavigationRoute;

const Auth0AuthenticatedRoute: React.FC<RouteWrapperProps> = (props) => {
  return (
    <Route
      path={props.path as string}
      render={() => {
        return (
          <PortalContextProvider>
            <ScreenLayout header={props.header}>
              <props.component />
            </ScreenLayout>
          </PortalContextProvider>
        );
      }}
    />
  );
};

export default withAuthenticationRequired(Auth0AuthenticatedRoute);
